import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { LabProcessingStatus } from "@/Common/Models/Lab/Enum/LabProcessingStatus";
import { IconVariant } from "@/DesignSystem";
import { Tag } from "@/DesignSystem/Molecules/Tag";

import styles from "./LabReportProcessingStatusComponent.module.scss";

interface LabReportStatusComponentProps {
    labStatus: LabProcessingStatus;
}

interface LabStatusView {
    variant: IconVariant;
    label: string;
}

function LabReportProcessingStatusComponent({ labStatus }: Readonly<LabReportStatusComponentProps>): JSX.Element {
    const { getText } = useTranslation();

    const labStatusMap = new Map<LabProcessingStatus, LabStatusView>([
        [LabProcessingStatus.Preliminary, { label: getText("LabProcessingStatus_PreliminaryLabel"), variant: "warning" }],
        [LabProcessingStatus.Pending, { label: getText("LabProcessingStatus_PendingLabel"), variant: "warning" }],
        [LabProcessingStatus.Cancelled, { label: getText("LabProcessingStatus_CancelledLabel"), variant: "error" }],
        [LabProcessingStatus.Final, { label: getText("LabProcessingStatus_FinalLabel"), variant: "success" }],
        [LabProcessingStatus.FinalCorrected, { label: getText("LabProcessingStatus_FinalCorrectedLabel"), variant: "success" }],
        [LabProcessingStatus.PartialCorrected, { label: getText("LabProcessingStatus_PartialCorrectedLabel"), variant: "brand" }],
        [LabProcessingStatus.Partial, { label: getText("LabProcessingStatus_PartialLabel"), variant: "brand" }]
    ]);

    const labStatusView: LabStatusView = labStatusMap.get(labStatus);

    if (labStatusView) {
        return (
            <span className={styles.tagContainer} data-cy={`lab-status-${LabProcessingStatus[labStatus]}`}>
                <Tag
                    label={labStatusView.label}
                    size="sm"
                    theme="light"
                    variant={labStatusView.variant}
                />
            </span>
        );
    }

    return <></>;
}

export { LabReportProcessingStatusComponent };
